import cx from 'classnames';
import { defineMessages, useIntl } from 'react-intl';

import type {
  NationViewProps,
  qubicaBaseSections,
} from '../NationView/NationView';

import RepresentativesCards from './RepresentativesCards';

import styles from './styles.module.css';
import QubicaBaseCard from './QubicaBaseCard';
import type {
  QubicaContactCardsStyleProps,
  QubicaContentProps,
  representativeSections,
} from './utils';

type SectionType =
  | (typeof representativeSections)[number]
  | (typeof qubicaBaseSections)[number];

const CardsSection = ({
  content,
  section,
  bg = 'white',
}: {
  content: NationViewProps['content'];
  section: SectionType;
  bg?: QubicaContactCardsStyleProps['bg'];
}) => {
  const intl = useIntl();
  return content[section].length > 0 ? (
    <div>
      {content[section].every(
        (el: QubicaContentProps) => el['@type'] === 'Contact',
      ) ? (
        <h3 className={styles.sectionTitle}>
          {intl.formatMessage(messages[section])}
        </h3>
      ) : (
        <h2 className={cx(styles.sectionTitle, styles.macroSectionTitle)}>
          {intl.formatMessage(messages[section])}
        </h2>
      )}
      <div className={styles.cardsContainer}>
        {content[section].map((el: QubicaContentProps) => {
          return el['@type'] === 'Contact' ? (
            <RepresentativesCards key={el['@id']} content={el} bg={bg} />
          ) : (
            <QubicaBaseCard key={el['@id']} content={el} bg={bg} />
          );
        })}
      </div>
    </div>
  ) : (
    <></>
  );
};

export default CardsSection;

const messages = defineMessages({
  district_sales_manager: {
    id: 'district_sales_manager',
    defaultMessage: 'District sales manager',
  },
  regional_sales_manager: {
    id: 'regional_sales_manager',
    defaultMessage: 'Regional sales manager',
  },
  SVP_sales: {
    id: 'SVP_sales',
    defaultMessage: 'SVP sales',
  },
  VP_sales: {
    id: 'VP_sales',
    defaultMessage: 'VP sales',
  },
  product_specialist: {
    id: 'product_specialist',
    defaultMessage: 'Product specialist',
  },
  technical_support: {
    id: 'technical_support',
    defaultMessage: 'Technical support',
  },
  representative_office: {
    id: 'representative_office',
    defaultMessage: 'Representative office',
  },
  crm: {
    id: 'crm',
    defaultMessage: 'CRM',
  },
  sales_assistant: {
    id: 'sales_assistant',
    defaultMessage: 'Sales Assistant',
  },
  us_parts_and_suppliera_distributor: {
    id: 'us_parts_and_suppliera_distributor',
    defaultMessage: 'US Parts and Supplies Distributor',
  },
  specific_locale: {
    id: 'specific_locale',
    defaultMessage: 'Locale in the current country',
  },
  related_locale: {
    id: 'related_locale',
    defaultMessage: 'Related locale',
  },
  headquarter: {
    id: 'Headquarters',
    defaultMessage: 'Headquarters',
  },
});
